// @spec GHG-STR-051
// @spec UXR-STR-001
import { createFileRoute, Outlet, redirect, useLocation } from '@tanstack/react-router';
import { Menu } from 'lucide-react';
import { useState } from 'react';

import { Button } from '@/components/ui/button';
import { GHGPeriodFilterBar, GHGPeriodProvider } from '@/features/ghg/components/GHGPeriodFilterBar';
import { GhgSidebarMobileNav } from '@/features/ghg/components/GhgSidebarMobileNav';
import { GhgSidebarNav } from '@/features/ghg/components/GhgSidebarNav';
import i18n from '@/lib/i18n';

const PERIOD_HIDDEN_PREFIXES = [
  '/ghg/setup',
  '/ghg/settings',
  '/ghg/activity-groups',
  '/ghg/market-instruments',
  '/ghg/integrations',
] as const;

export const Route = createFileRoute('/_authenticated/ghg')({
  beforeLoad: ({ location }) => {
    if (location.pathname === '/ghg') {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/ghg/overview', replace: true });
    }
    return {
      getTitle: () => i18n.t('routeTitles.ghgEmissions'),
    };
  },
  component: GhgLayout,
});

function GhgLayout() {
  return (
    <GHGPeriodProvider>
      <GhgLayoutInner />
    </GHGPeriodProvider>
  );
}

function GhgLayoutInner() {
  const location = useLocation();
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const hidePeriodBar = PERIOD_HIDDEN_PREFIXES.some((prefix) =>
    location.pathname.startsWith(prefix)
  );

  return (
    <div className="flex min-h-[calc(100vh-4rem)] -mx-4 -mt-4 md:-mx-6 md:-mt-6">
      <GhgSidebarMobileNav open={mobileNavOpen} onOpenChange={setMobileNavOpen} />
      <GhgSidebarNav />

      <div className="flex-1 min-w-0">
        <div className="sticky top-0 z-10 flex items-center border-b bg-background px-4 py-2 md:hidden">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => {
              setMobileNavOpen(true);
            }}
            aria-label="Open GHG navigation"
            className="h-11 w-11"
          >
            <Menu className="h-5 w-5" />
          </Button>
          <span className="ml-2 text-sm font-medium text-muted-foreground">GHG Emissions</span>
        </div>

        {!hidePeriodBar && <GHGPeriodFilterBar />}

        <Outlet />
      </div>
    </div>
  );
}
